import { useSelector } from "react-redux";
import InstainsureLogo from "../../assets/images/AD/10/21/26075_21.svg";
import BelairLoader from "../../assets/images/AD/10/21/26075_37.svg";
import { BELAIR_PARTNER } from "../../configs/partner";
import { LoadingSpinner } from "./LoadingSpinner";
export default function Loader({ ...props }) {
  const urlParams = new URLSearchParams(window?.location?.search);
  const _source = urlParams.get("source");
  const {
    pasaStore: { source, openMarket }
  } = useSelector((state) => state);
  
  return (
    <div className="loader">
      <section className="loader_wrapper">
  {[openMarket?.source?.toUpperCase(), _source?.toUpperCase()].includes("LEAD_CAPTURE") ? (
    <div>
      <LoadingSpinner />
    </div>
  ) : (
    <>
      {!["RTL_HBANK"].includes(openMarket?.source?.toUpperCase()) &&
       !["RTL_HBANK"].includes(source?.toUpperCase()) && (
        <img
          src={
            BELAIR_PARTNER.includes(source) ? BelairLoader : InstainsureLogo
          }
          className="_logo"
          alt="InstaInsure"
        />
      )}
      <p>Please Wait...</p>
    </>
  )}
</section>

    </div>
  );
}
